import {
  ComponentLabel,
  UiZoneWidgetConfig,
  WorkflowWidgetConfig,
} from '@finxone-platform/shared/sys-config-types';

export const mapTextWidgetFunction = function mapTextWidget(item: WorkflowWidgetConfig): UiZoneWidgetConfig {
  return {
    name: item.name as ComponentLabel,
    attributes: item.widgetConfiguration?.attributes,
    uniqueId: item.uniqueId,
    gridPosition: item.gridPosition,
  };
};
